import { SlideOut } from '@interstate/components/SlideOut';
import { Box } from '@interstate/components/Box';
import { useDispatch, useSelector } from 'react-redux';

import * as deskingGlobalSelectors from '@makemydeal/dr-dash-store/selectors/deskingGlobalSelectors';
import * as accessoriesActionCreators from '@makemydeal/dr-dash-store/actions/accessoriesActionCreators';
import AccessoriesCatalogActivity from './AccessoriesCatalogActivity';

export const AccessoriesCatalogSlideOut = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(deskingGlobalSelectors.isAccessoriesCatalogSlideOutOpen);

    const handleClose = () => {
        dispatch(accessoriesActionCreators.closeAccessoriesCatalogSlideOut());
    };

    return (
        <SlideOut
            show={isOpen}
            onHide={handleClose}
            position="right"
            panelWidth="100vw"
            data-testid="slideout-accessories-catalog"
            sx={{
                '& .ids-SlideOut-content': {
                    height: '100%'
                }
            }}
        >
            <Box height="100%" display="flex" flexDirection="column" position="relative" overflow="auto">
                <AccessoriesCatalogActivity />
            </Box>
        </SlideOut>
    );
};
